<template>
  <div class="attachments_wrapper">
    <div class="scroll">
      <ul class="modal__control_file-list">
        <li
          v-for="(attachment, key) in paginatedAttachmentList"
          class="modal__control_file-listitem"
        >
          {{ attachment.name
          }}<span
            class="modal__control_file-itemremover"
            @click="removeAttachment(key)"
          ></span>
        </li>
      </ul>
    </div>
    <table class="modal__control_file-list-control">
      <tr>
        <td>
          <span v-if="this.attachmentsTotal === 1"
            >{{ this.attachmentsTotal }} Anhang</span
          >
          <span v-if="this.attachmentsTotal > 1"
            >{{ this.attachmentsTotal }} Anhänge</span
          >
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: "ControlAttachmentList",
  props: {
    new: {
      type: Number,
      default: 0
    },
    attachments: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pageNumber: 0,
      displayNumber: 1,
      size: 5
    };
  },
  methods: {
    removeAttachment(key) {
      this.$emit("remove-attachment", key);
    }
  },
  computed: {
    paginatedAttachmentList() {
      return this.attachments;
    },
    attachmentsTotal() {
      return this.attachments.length;
    }
  }
};
</script>
